import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/account/tickets/new")({
  head: () => {
    const isEn = typeof window !== "undefined" && localStorage.getItem("saba_lang") === "en";
    return { meta: [{ title: isEn ? "New Ticket | BAZZAR 3D" : "تذكرة جديدة | بازار ثرى دى" }] };
  },
  component: lazyRouteComponent(() => import("@/pages-lazy/account-tickets-new")),
});
